import React from "react";
import { YMInitializer } from "react-yandex-metrika";

export const Footer = () => {
    return (
        <footer
            className="footer"
            style={{
                background: "#0b1220",
                color: "#dbeafe",
                padding: "40px 16px",
                fontFamily: "Inter, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
            }}
            id="footer"
        >
            <div className="container"
                style={{
                    maxWidth: 1100,
                    margin: "0 auto",
                }}
            >
                <div className="footer__inner"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: 24,
                    }}
                >
                    <div
                        className="footer__contacts"
                        style={{ minWidth: 240, flex: "1 1 320px" }}
                    >
                        <div style={{ fontSize: 14, opacity: 0.9, marginBottom: 8 }}>
                            Контакты
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            <a
                                href="tel:+79309680880"
                                className="tel"
                                style={{
                                    color: "#fff",
                                    textDecoration: "none",
                                    fontWeight: 600,
                                }}
                            >
                                +7 (930) 968-08-80
                            </a>
                            <a
                                href="mailto:mail@info@inter-graphics-msk.ru"
                                className="mail"
                                style={{
                                    color: "#9fb4d8",
                                    textDecoration: "none",
                                    fontSize: 14,
                                }}
                            >
                                info@inter-graphics-msk.ru
                            </a>
                        </div>
                    </div>

                    <div
                        className="footer__social"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end",
                            minWidth: 180,
                            gap: 12,
                        }}
                    >
                        <YMInitializer accounts={[105197104]} options={{ webvisor: true }} />
                    </div>
                </div>

                <div
                    className="footer__bottom"
                    style={{
                        marginTop: 28,
                        borderTop: "1px solid rgba(255,255,255,0.04)",
                        paddingTop: 18,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 12,
                        flexWrap: "wrap",
                        fontSize: 13,
                        color: "#94a3b8",
                    }}
                >
                    <div>© Неговорова Дарина Александровна, 2026, Москва</div>
                    <div style={{ opacity: 0.9 }}>Политика конфиденциальности</div>
                </div>
            </div>
        </footer>
    )
}